import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip'
import { useTranslation } from '@Globals/Translations'

export const TwoForOneChip: FC<ChipProps> = ({ size = 'small' }) => {
  const { t } = useTranslation()

  return (
    <Chip
      fadedBackground
      size={size}
      uppercase
    >
      {t('products:TWO_FOR_ONE')}
    </Chip>
  )
}

